module.exports = __webpack_public_path__ + "static/media/calling-all-reactive-agents-2.ed0ee198.jpg";